import React from 'react';
import MessageContent from '@sendbird/uikit-react/ui/MessageContent';
import { correctURL } from '../utils/urlCorrection';

/**
 * SendBirdのOGメッセージレンダリング用カスタムフック
 * 相対URLを絶対URLに変換してリンクプレビューの問題を解決
 * URL重複修正処理も含む
 */
export const useSendBirdOGMessageRenderer = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderOGIImageMessage = (props: any) => {
    // OGイメージメッセージ（リンクプレビュー）のカスタマイズ
    const { message } = props;
    const { ogMetaData } = message;

    if (ogMetaData && ogMetaData.url) {
      try {
        // URL修正ユーティリティを使用してURLを修正
        const correctedUrl = correctURL(ogMetaData.url);

        // OGMetaDataを更新
        const updatedOGMetaData = {
          ...ogMetaData,
          url: correctedUrl,
        };

        // 更新されたpropsで元のコンポーネントをレンダリング
        const updatedMessage = {
          ...message,
          ogMetaData: updatedOGMetaData,
        };

        // カスタムOGメッセージハンドラーを追加
        const enhancedProps = {
          ...props,
          message: updatedMessage,
          onClick: (e: Event) => {
            e.preventDefault();
            window.open(correctedUrl, '_blank', 'noopener,noreferrer');
          }
        };

        return (
          <MessageContent
            {...enhancedProps}
          />
        );
      } catch (error) {
        // エラーが発生した場合は元のURLをそのまま使用
        return <MessageContent {...props} />;
      }
    }

    // デフォルトのレンダリング
    return <MessageContent {...props} />;
  };

  // メッセージコンテンツのレンダリング用関数
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderMessageContent = (contentProps: any) => {
    if (contentProps?.message?.message) {
      if (contentProps?.message?.message.trim().length === 0) {
        return <div />;
      }
    }

    // OGメタデータのURL重複修正処理
    if (contentProps?.message?.ogMetaData?.url) {
      try {
        const originalUrl = contentProps.message.ogMetaData.url;
        const correctedUrl = correctURL(originalUrl);

        if (correctedUrl !== originalUrl) {
          // 直接メッセージオブジェクトを変更（ミューテーション）
          // eslint-disable-next-line no-param-reassign
          contentProps.message.ogMetaData.url = correctedUrl;
        }
      } catch (error) {
        // エラーが発生した場合は処理をスキップ
      }
    }
    
    return <MessageContent {...contentProps} />;
  };

  return {
    renderOGIImageMessage,
    renderMessageContent,
  };
}; 
